import type { NavLinkProps } from 'react-router';
import { NavLink } from 'react-router';

import type { SideBarMenuItem } from '@/type';

import style from './style';

type MenuItemProps = SideBarMenuItem &
  Omit<NavLinkProps, 'to'> &
  React.RefAttributes<HTMLAnchorElement>;

const MenuItem = ({
  disabled,
  name,
  path,
  Icon,
  ...linkProps
}: MenuItemProps) => {
  return (
    <NavLink
      {...linkProps}
      to={path}
      className={({ isActive }) =>
        style.Category(disabled ? 'disabled' : isActive ? 'active' : 'default')
      }
      onClick={e => {
        if (!disabled) return;

        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Icon className={style.CategoryIcon} />
      <span className={style.ItemSpan}>{name}</span>
    </NavLink>
  );
};

export default MenuItem;
